import { render, staticRenderFns } from "./RegisterSongStep2bEnterChords.vue?vue&type=template&id=f909a5d4&scoped=true"
import script from "./RegisterSongStep2bEnterChords.vue?vue&type=script&lang=ts"
export * from "./RegisterSongStep2bEnterChords.vue?vue&type=script&lang=ts"
import style0 from "./RegisterSongStep2bEnterChords.vue?vue&type=style&index=0&id=f909a5d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f909a5d4",
  null
  
)

export default component.exports